module.exports = __webpack_public_path__ + "static/img/book17.2f91689.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book17.jpg
// module id = 8cz9
// module chunks = 1